import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
  API_CopyTemplate_Integration,
  gAPI_Property_List_By_Group,
  postAPI_Create_A_Message,
  API_HelpCenter_Integration,
} from '../../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import Validation from '../../../../../../components/Validation';
import { ChromePicker } from 'react-color';
import { setBackGroundColor } from '../../../integration/style/DigitalAssistantStyle';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;
let arr = [];
const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;
export default function AddHelpCenterIntegration({ visible, toggle, imageDomain }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  let [iseditMode, setEditMode] = useState({ primaryColor: false, staticColor: false, });
  const [edit, setEdit] = useState(true);
  const [error, setError] = useState(true);
  const [integrationName, setIntegrationName] = useState("Web Widget for website");
  const [apiTemplate, setApiTemplate] = useState("default");
  const [templateData, setTemplateData] = useState({
    fromGroupId: fromGroupId,
    fromPropertyId: fromPropertyId,
    toGroupId: getGroupID(),
    isForm: false,
    isHelpItem: false,
    isWeb: false,
    isMessengerX: true,
    isAssistantMenu: false,
    isFAQ: false,
    appearance: null,
    name: '',
    properties: []
  });
  const [appearanceData, setAppearanceData] = useState({ primaryColor: "#424344", staticColor: "#000", contrastColor: "white" });
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',
    DefaultRuleNudges: [
      {
        EyeCatcher: {
          Code: EyeCatcherCode1,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode1,
          FilterTags: null,
        },
        DelayInMilliseconds: 5000,
        DelayInMillisecondsInMobile: 5000,
        DisableInDesktop: false,
        DisableInMobile: false
      },
      {
        EyeCatcher: {
          Code: EyeCatcherCode2,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode2,
          FilterTags: null,
        },
        DelayInMilliseconds: 15000,
        DelayInMillisecondsInMobile: 15000,
        DisableInDesktop: false,
        DisableInMobile: false
      },
    ],
    BotSettings: {
      Name: 'Bob Help Center',
      Tagline: 'Hotel Assistant',
      Colours: {
        Header: '#dfce90',
        BotBot: '#ffffff',
        BotUser: '#dfcf92',
        BotButton: '#da291c',
        BotBackground: '#e9eef4',
        HeaderText: '#4a5051',
        BotBotText: '#353f48',
        BotUserText: '#353f48',
        BotButtonText: '#4a5051',
      },
      Text: {
        WebPoweredBy1: 'Powered by',
        WebPoweredBy2: 'BookMeBob',
      },
      Urls: {
        Icon: `${imageDomain}/images/avatars/bob.png`,
        CrossIcon: 'https://webchat.bookmebob.com/res/close_cross.png',
        MinimiseIcon: 'https://webchat.bookmebob.com/res/minus.png',
        WebCookies: 'https://www.bookmebob.com/cookies',
        WebPoweredBy: 'https://www.bookmebob.com',
      },
      AssistantDetails: [{
        Name: "Bob Help Center",
        Title: "",
        SubTitle: "",
        Locale: "en"
      }]
    },
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (property.length === 1 && templateData.properties.length === 0) {
      setTemplateData({ ...templateData, properties: [property[0].id] });
    }
  }, [property, templateData.properties]);

  const handleNameChange = (e) => {
    setIntegrationName(e.target.value);
    e.persist();
    setTemplateData({ ...templateData, name: e.target.value });
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      var property = [e.target.value];
      setTemplateData({ ...templateData, properties: property });
    }
    if (!e.target.checked) {
      var property = [];
      setTemplateData({ ...templateData, properties: property });
    }
    // if (e.target.checked) {
    //   arr[e.target.id] = e.target.value;
    // }
    // if (!e.target.checked) {
    //   arr[e.target.id] = undefined;
    // }
    // const filterList = arr.filter((elem) => elem !== undefined || null);
    // setInputData({ ...inputData, Properties: filterList });
    // const val = [];
    // if (e.target.checked) {
    //   val.push(e.target.value);
    // }
    // setInputData({ ...inputData, Properties: val });
  };
  const handleSave = async () => {
    if (templateData.properties.length === 0) {
      setMsg(["Please select at least one property before continuing."]);
      setOpen(true);
      return;
    }
    templateData.appearance = appearanceData;
    templateData.name = integrationName;
    AxiosAPI({
      method: 'post',
      url: `${API_CopyTemplate_Integration}`,
      data: templateData,
    }).then(
      (res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300)
        }
      }
    );
    /**  When creating a response for a integration, don't need pass a property id*/
    // Axios.all([
    //   AxiosAPI({
    //     method: 'post',
    //     url: postAPI_Create_A_Message,
    //     data: {
    //       GroupId: getGroupID(),
    //       Code: GreetingCode1,
    //       Language: 'en-US',
    //       Channel: 'WebsiteDirectLine',
    //       Default: ['Hi, how can I help?'],
    //       Overrides: {},
    //     },
    //   }),
    //   AxiosAPI({
    //     method: 'post',
    //     url: postAPI_Create_A_Message,
    //     data: {
    //       GroupId: getGroupID(),
    //       Code: EyeCatcherCode1,
    //       Language: 'en-US',
    //       Channel: 'WebsiteDirectLine',
    //       Default: ['Hi, how can I help?'],
    //       Overrides: {},
    //     },
    //   }),
    //   AxiosAPI({
    //     method: 'post',
    //     url: postAPI_Create_A_Message,
    //     data: {
    //       GroupId: getGroupID(),
    //       Code: GreetingCode2,
    //       Language: 'en-US',
    //       Channel: 'WebsiteDirectLine',
    //       Default: [
    //         'Hi, I can help you with bookings or answer any questions you may have.',
    //       ],
    //       Overrides: {},
    //     },
    //   }),
    //   AxiosAPI({
    //     method: 'post',
    //     url: postAPI_Create_A_Message,
    //     data: {
    //       GroupId: getGroupID(),
    //       Code: EyeCatcherCode2,
    //       Language: 'en-US',
    //       Channel: 'WebsiteDirectLine',
    //       Default: [
    //         'Hi, I can help you with bookings or answer any questions you may have.',
    //       ],
    //       Overrides: {},
    //     },
    //     API_HelpCenter_Integration,
    //   }),
    //   AxiosAPI({
    //     method: 'post',
    //     url: 
    // ,
    //     data: inputData,
    //   }).then((res) => {
    //     if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
    //       && res.data.Messages !== null && res.data.Messages.length > 0) {
    //       setMsg(res.data.Messages);
    //       setOpen(true);
    //     }
    //     else {
    //       toggle();
    //       setTimeout(() => {
    //         window.location.reload();
    //       }, 300)
    //     }
    //   })
    // ]).then(() => { }
    // );
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add Web Widget for Property Website</h6>
                <Separator className="mb-3" />

                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      value={integrationName}
                      onChange={handleNameChange}
                      placeholder="Web Widget for website"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Select your primary website/brand colors.</Label>
                    <Row>
                      <Colxx md={6}>
                        <div>
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                              <span className=''>Primary Color​</span>
                            </div>
                            <div className='col-md-12'>
                              <InputGroup>
                                <Input
                                  className=""
                                  type="text"
                                  onChange={(e) => {
                                    setAppearanceData({ ...appearanceData, primaryColor: e.target.value });
                                  }}
                                  value={appearanceData.primaryColor}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText onClick={() => {
                                    setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                  }}
                                    className="color-square" style={setBackGroundColor(appearanceData.primaryColor)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.primaryColor && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                            <ChromePicker disableAlpha={true} className='ml-2'
                              style={{ width: '200px' }}
                              color={appearanceData.primaryColor}
                              onChangeComplete={(e) => {
                                if (edit) {
                                  setAppearanceData({ ...appearanceData, primaryColor: e.hex });
                                  setEditMode({ ...iseditMode, primaryColor: false });
                                } else setError(true);
                              }}
                            />
                          </div>
                        </div>}
                      </Colxx>
                      <Colxx sm={6}>
                        <Label>Contrast Text Color</Label>
                        <div className="d-flex">
                          <CustomInput
                            type="radio"
                            id="white"
                            value={"white"}
                            onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                            checked={appearanceData.contrastColor === "white" ? true : false}
                          >White</CustomInput>
                          <CustomInput
                            className="ml-2"
                            type="radio"
                            id="black"
                            value={"black"}
                            onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                            checked={appearanceData.contrastColor === "black" ? true : false}
                          >Black</CustomInput>
                        </div>
                      </Colxx>
                    </Row>
                  </FormGroup>
                  <FormGroup className="mt-2">
                    <Label style={{ marginTop: '0.5rem', marginBottom: '0rem' }}>Select one property for this integration.</Label>
                    <div className='integration-property'>
                      {sortPropertyListByName(property).map((p, index) => {
                        const isSingleProperty = property.length === 1;
                        const isChecked = isSingleProperty || templateData.properties.includes(p.id);

                        // const greyStyle = !p.isBmb
                        //   ? { opacity: 0.5, pointerEvents: "none" } // If disabled completely
                        //   : {};

                        return (
                          <div key={p.id}
                          //  style={greyStyle}
                          >
                            <CustomInput
                              type="radio"
                              id={`prop-${index}`}
                              label={p.name}
                              value={p.id}
                              checked={isChecked}
                              onChange={handleCheckChange}
                            />
                          </div>
                        );
                      })}

                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  <Button color="primary" size="xs" onClick={handleSave}>
                    Create New Integration
                  </Button>
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment >
  );
}
